import React from 'react'
import styled from 'styled-components';
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

const Div = styled.div`
    height: 100vh;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .coming-button{
        border: none;
        padding: 0.5rem 1.5rem;
        border-radius: 45px;
        background: #0d6efd;
        color: white;
    }
    .para-1{
        font-size: 30px;
    }
    .para-2{
        font-size: 50px;
    }
`;

export default function ComingSoon(){
    const navigate = useNavigate()
    return(
        <Div>
            <p className='mb-2 para-1'>We're Working on it.</p>
            <p className='mb-2 para-2'>Coming Soon !!</p>
            <button className="coming-button" onClick={() => navigate("/home")}><FaArrowLeftLong/> Expore More</button>
        </Div>
    );
}